export const ImageGetSchema = {
    id: 'id',
    pages: {
        general: {
            pageId: 'general',
            comment: 'comment',
            displayDescription: 'displayDescription',
            reportPath: 'reportPath',
        },
        history: {
            pageId: 'history',
            createTime: 'createTime',
            lastTime: 'lastTime'
        }
    }
}

export const ImageGetListSchema = {
    name: 'name',
    description: 'description',
    usageInReports: 'usageInReports'
}

export const ImageFilterSchema = {
    freeTextSearch: 'freeTextSearch',
    creationDate: 'creationDate',
    modificationDate: 'modificationDate'
}